import React, { useEffect, useRef, useState } from "react";
import { FaCheck, FaChevronDown, FaGlobeAmericas } from "react-icons/fa";
import { useIdioma } from "./context/IdiomaContext";

const OPCIONES = [
  { codigo: "es", nombre: "Español", abreviatura: "ES" },
  { codigo: "en", nombre: "English", abreviatura: "EN" }
];

export default function SelectorIdioma() {
  const { language, setLanguage, t } = useIdioma();
  const [abierto, setAbierto] = useState(false);
  const contenedor = useRef(null);
  const boton = useRef(null);
  const actual = OPCIONES.find((opcion) => opcion.codigo === language) || OPCIONES[0];

  useEffect(() => {
    if (!abierto) return undefined;
    const cerrarFuera = (event) => {
      if (contenedor.current && !contenedor.current.contains(event.target)) setAbierto(false);
    };
    document.addEventListener("mousedown", cerrarFuera);
    return () => document.removeEventListener("mousedown", cerrarFuera);
  }, [abierto]);

  const seleccionar = (codigo) => {
    setLanguage(codigo);
    setAbierto(false);
    boton.current?.focus();
  };

  const manejarTecla = (event) => {
    if (event.key === "Escape") {
      setAbierto(false);
      boton.current?.focus();
    }
  };

  return (
    <div className="language-selector" ref={contenedor} onKeyDown={manejarTecla}>
      <button
        ref={boton}
        type="button"
        className={`language-selector__button${abierto ? " is-open" : ""}`}
        onClick={() => setAbierto((valor) => !valor)}
        aria-haspopup="listbox"
        aria-expanded={abierto}
        aria-label={`${t("Idioma")}: ${actual.nombre}. ${t("Cambiar idioma")}`}
      >
        <FaGlobeAmericas className="language-selector__icon" aria-hidden="true" />
        <span className="language-selector__name">{actual.nombre}</span>
        <FaChevronDown className="language-selector__chevron" size="11px" aria-hidden="true" />
      </button>

      {abierto && (
        <ul className="language-selector__menu" role="listbox" aria-label={t("Seleccionar idioma")}>
          {OPCIONES.map((opcion) => {
            const seleccionada = opcion.codigo === language;
            return (
              <li
                key={opcion.codigo}
                role="option"
                aria-selected={seleccionada}
                tabIndex={0}
                className={`language-selector__option${seleccionada ? " is-selected" : ""}`}
                onClick={() => seleccionar(opcion.codigo)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    seleccionar(opcion.codigo);
                  }
                }}
              >
                <FaGlobeAmericas aria-hidden="true" />
                <span className="language-selector__option-text">
                  <strong>{opcion.nombre}</strong>
                  <small>{opcion.abreviatura}</small>
                </span>
                {seleccionada && <FaCheck className="language-selector__check" size="12px" aria-hidden="true" />}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
